import ActionColumnComponent from "../../components/ActionColumn/ActionColumn";

export const EmergencyColumns = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({ viewModal, updateModal, deleteRecord });

  return {
    "Family Contacts (Local)": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Relationship",
        dataIndex: "Relationship",
        key: "relationship",
      },
      {
        title: "Street",
        dataIndex: "Street",
        key: "street",
      },
      {
        title: "City",
        dataIndex: "City",
        key: "city",
      },
      {
        title: "State",
        dataIndex: "State",
        key: "state",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
      },
      actionColumn,
    ],
    "Family Contacts (Distant)": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Relationship",
        dataIndex: "Relationship",
        key: "relationship",
      },
      {
        title: "Street",
        dataIndex: "Street",
        key: "street",
      },
      {
        title: "City",
        dataIndex: "City",
        key: "city",
      },
      {
        title: "State",
        dataIndex: "State",
        key: "state",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
      },
      actionColumn,
    ],
    "Insurance Agents": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Company",
        dataIndex: "Company",
        key: "company",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
      },
      actionColumn,
    ],
    "Utility Companies": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
      },
      {
        title: "Account Number",
        dataIndex: "Account Number",
        key: "accountnumber",
      },
      actionColumn,
    ],
    "Local Emergency Management Office": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
      },
      actionColumn,
    ],
    "Evacuation Centers": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
      },
      {
        title: "Street",
        dataIndex: "Street",
        key: "street",
      },
      {
        title: "City",
        dataIndex: "City",
        key: "city",
      },
      actionColumn,
    ],
    "Pet Emergency Contacts/Shelters": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
      },
      {
        title: "Street",
        dataIndex: "Street",
        key: "street",
      },
      {
        title: "City",
        dataIndex: "City",
        key: "city",
      },
      actionColumn,
    ],
  };
};

// Usage example in your component:
// const { viewModal, updateModal, deleteRecord } = yourPropsOrContext;
// const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);
